import switcher from './switcher'

export default (...args) => switcher(...args)()
